import { Empty, List } from '@faceup/ui-base'
import type { ReactNode } from 'react'

type ActivityLogItem = {
  id: string
  /** Who did it: a member, an employee or FaceUp, each drawn by the caller */
  avatar: ReactNode
  actorName: string | null
  action: ReactNode
  createdAt: string
}

type ActivityLogProps = {
  logs: ActivityLogItem[]
  noDataMessage?: ReactNode
}

export const ActivityLog = ({ logs, noDataMessage }: ActivityLogProps) => {
  return (
    <List>
      {logs.length === 0 && <Empty description={noDataMessage} />}
      {logs.map(log => (
        <List.Item key={log.id} className='flex flex-nowrap items-center justify-between gap-4'>
          <div className='shrink-0'>{log.avatar}</div>
          <div className='flex grow flex-col'>
            <div>
              {log.actorName && <span className='sensitive me-1 font-bold'>{log.actorName}</span>}
              <span className='sensitive'>{log.action}</span>
            </div>
            <span className='text-colorTextDescription text-xs'>{log.createdAt}</span>
          </div>
        </List.Item>
      ))}
    </List>
  )
}
